var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-part1"},[_c('title1',{staticStyle:{"margin-top":"100px","font-size":"30px"},attrs:{"type":"2","title":"订单统计"}}),_c('dv-scroll-board',{staticClass:"mt-80",staticStyle:{"width":"100%","height":"420px"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }